import { SingleChangeEvent, SingleSelectControl } from "@dgs/core";
import { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ContactViewIndexResource } from "../../shared/types";
import { useGlobalContactView } from "../global/GlobalContactViewProvider";
import { useLocalContactView } from "./LocalContactViewProvider";

const StyledSingleSelectControl = styled(SingleSelectControl)`
	padding-bottom: 0;
`;

export const LocalContactViewSwitcher: FC = () => {
	const { t } = useTranslation();
	const { contactViews, favoriteContactViews } = useGlobalContactView();
	const { localContactView, setLocalContactView } = useLocalContactView();

	const changeHandler = useCallback(
		(e: SingleChangeEvent<unknown>) => {
			setLocalContactView(e.target.value as ContactViewIndexResource);
		},
		[setLocalContactView],
	);

	return (
		<StyledSingleSelectControl
			options={favoriteContactViews.concat(contactViews)}
			onChange={changeHandler}
			value={localContactView}
			name="localContactViewSelect"
			onClear={() => setLocalContactView(null)}
			placeholder={t("Select a contact view")}
			clearable={true}
		/>
	);
};
